// index.ts — entry point for the combat-log render bundle.
//
// esbuild bundles everything reachable from here into includes/js/dist/log-bundle.js.
// All 14 window globals are emitted in one place so handleRollInsert (template.js)
// and buildLog (side-panels-init.js) keep their existing window.X calls unchanged.

import {
    renderSimpleLogRow,
    renderLogLineThumbnail,
    renderLogTimestamp,
    renderHouseRuleBanner,
    _ftAppendToExistingGroup,
    normalizePicUrl,
} from './log-render';

import {
    renderContestingSummary,
    renderDeathSessionBody,
    renderTradeSessionBody,
    renderGateFailureRollup,
    renderLogWindowFromJson,
    activateLogCollapseTasks,
} from './containers';

import { interpretRollResultArr } from './interpret';
import { parseText } from '../shared/parse-text';

declare global {
    interface Window {
        renderSimpleLogRow: typeof renderSimpleLogRow;
        renderLogLineThumbnail: typeof renderLogLineThumbnail;
        renderLogTimestamp: typeof renderLogTimestamp;
        renderHouseRuleBanner: typeof renderHouseRuleBanner;
        _ftAppendToExistingGroup: typeof _ftAppendToExistingGroup;
        normalizePicUrl: typeof normalizePicUrl;
        renderContestingSummary: typeof renderContestingSummary;
        renderDeathSessionBody: typeof renderDeathSessionBody;
        renderTradeSessionBody: typeof renderTradeSessionBody;
        renderGateFailureRollup: typeof renderGateFailureRollup;
        renderLogWindowFromJson: typeof renderLogWindowFromJson;
        activateLogCollapseTasks: typeof activateLogCollapseTasks;
        interpretRollResultArr: typeof interpretRollResultArr;
        parseText: typeof parseText;
    }
}

Object.assign(window, {
    renderSimpleLogRow,
    renderLogLineThumbnail,
    renderLogTimestamp,
    renderHouseRuleBanner,
    _ftAppendToExistingGroup,
    normalizePicUrl,
    renderContestingSummary,
    renderDeathSessionBody,
    renderTradeSessionBody,
    renderGateFailureRollup,
    renderLogWindowFromJson,
    activateLogCollapseTasks,
    interpretRollResultArr,
    parseText,
});
